<template>
  <v-card flat color="rgb(81, 167, 248, .1)" height="74" width="170">
    <v-card-text class="d-flex align-center">
          <v-avatar rounded color="white">
            <v-icon color="titleText"> mdi-chart-line </v-icon>
          </v-avatar>
          <div class="ml-3">
            <h4 class="darkGrey--text">R<sup>2</sup></h4>
            <h3 class="blue--text">
              {{ this.Rsquared }}%
            </h3>
          </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default ({
  props: {
    divdata: [],
  },
  data: () => ({
    Rsquared: "0",
    tempctrldata: [],
  }),
  methods: {
   
    getdivtext() {
      this.Rsquared = 0;
      let temp = [];
      temp = this.tempctrldata;
      this.Rsquared= temp.filter((a) => a.region == "national")[0].rsquared;
    },
  },
  mounted() {
    this.tempctrldata = this.divdata;
  this. getdivtext();
   // this.getroi_activity();
    //this.binddata();
   
  },
  watch: {
    divdata: function (val) {
     // alert("Onoad -" + val);
      if (val) {
        this.tempctrldata = this.divdata;
    this.getdivtext();
      }
    },
  },
});
</script>

<style scoped>
headerbox {
  font-weight: bold;
  font-style: italic;
  font-size: 20px;
  color: gray;
}

.headerboxtitle {
  font-size: 20px;
  color: gray;
  text-align: center;
  font-style: italic;
  font-weight: bold;
}
.card1 {
  background-color: #17a2b8;
}
</style>
